// eslint-disable-next-line import/prefer-default-export
export const doValuesMatchSearch = (search, values) => {
  const lowerCaseSearch = search?.toLowerCase();

  return values.reduce(
    (acc, current) => acc || current?.toLowerCase().includes(lowerCaseSearch),
    false
  );
};
